<template>
  <div class="balance-scale"
       :class="{'balance-scale--mobile': isMobile}"
       v-if="total > 0"
       :data-title="$t('balanceScale.text')">
    <svg id="svg"
         width="134"
         height="134"
         xmlns="http://www.w3.org/2000/svg">
      <circle id="balance-scale--background"
              r="57"
              cx="67"
              cy="67"
              fill="#333"
              :stroke="progressbarBgColor" ></circle>
      <circle id="balance-scale--progressbar"
              r="57"
              cx="-67"
              cy="-67"
              fill="transparent"
              stroke-dasharray="358"
              :stroke="progressbarColor"
              :stroke-dashoffset="strokeDashOffset+'px'"></circle>
    </svg>
    <div class="balance-scale--description">
      <span class="balance-scale--description-percent" v-html="percentText"></span>
      {{ $t('balanceScale.text.short') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'BalanceScale',
  props: {
    total: {
      type: Number,
      default: 0
    },
    current: {
      type: Number,
      default: 0
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    strokeDashOffset () {
      let koef = (Math.max(0, Math.min(this.total, this.current))) / this.total
      //  stroke-dasharray shifted by percent
      return 358 * koef
    },
    percentText () {
      return Math.ceil((1 - (Math.max(0, Math.min(this.total, this.current))) / this.total) * 100) + '%'
    },
    progressbarColor () {
      let percent = 1 - (Math.max(0, Math.min(this.total, this.current))) / this.total
      return (percent > 0.5) ? '#359D3F' : ((percent > 0.3) ? '#F5A812' : '#FF2F00')
    },
    progressbarBgColor () {
      let percent = 1 - (Math.max(0, Math.min(this.total, this.current))) / this.total
      return (percent > 0.5) ? 'rgba(53, 157, 63, 0.2)' : ((percent > 0.3) ? 'rgba(245, 168, 18, 0.2)' : 'rgba(255, 47, 0, 0.2)')
    }
  }
}
</script>

<style scoped lang="sass">

#balance-scale--progressbar
  //stroke: #359D3F
  transform: rotate(-90deg) scaley(-1)
  stroke-width: 6px

#balance-scale--background
  stroke-width: 6px

.balance-scale
  cursor: pointer
  position: absolute
  display: block
  height: 134px
  width: 134px
  background: #333333
  border-radius: 50%
  right: 15px
  bottom: 10%
  z-index: 2

  +mmax($tablet)
    transform: scale(0.8)
    transform-origin: bottom right

  &--mobile
    transform: scale(0.7)
    right: 0
    bottom: 0
    transform-origin: bottom right

    +mmax($tablet)
      transform: scale(0.5)

      .balance-scale--description
        font-size: 18px
        padding: 14px 22px 22px 22px

  &[data-title]:hover:after
    content: attr(data-title)
    position: absolute
    top: -50px
    left: 50%
    transform: translateX(-50%)
    width: 270px
    height: 42px
    background-image: url('/img/svgo/black-tooltip.svg')
    background-position: center
    background-size: cover
    background-repeat: no-repeat
    color: $white-text-color
    font-size: 14px
    line-height: 45px
    display: flex
    justify-content: center
    pointer-events: none

.balance-scale--description
  position: absolute
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)
  color: white
  width: 100%
  height: 100%
  padding: 26px 22px 22px 22px
  text-align: center
  font-weight: 500
  font-size: 12px
  line-height: 130%

.balance-scale--description-percent
  font-style: normal
  font-weight: 500
  font-size: 32px
  line-height: 41px
</style>
